import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateSebelUser = ({ visible, handleClose, initialData = '', onSubmit }) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            sabelUserId: initialData?.sabelUserId || '',
            sabelUserName: initialData?.sabelUserName || '',
        },
        validateOnMount: false,
        validateOnBlur: true,
        validationSchema: Yup.object({
            sabelUserId: Yup.string().required('Siebel User ID is required'),
            sabelUserName: Yup.string().required('Siebel User Name is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            const payload = {
                sabelUserId: values.sabelUserId,
                sabelUserName: values.sabelUserName,
            };

            if (initialData?.sabelUserId) {
                payload.sp = "usp_UpdateSabelUser";
                payload.id = initialData?.id; // if needed for update
            } else {
                payload.sp = "usp_InsertSabelUser";
            }

            onSubmit(payload,onClose);
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    useEffect(() => {
        if (initialData?.sabelUserId) {
            formik.setFieldValue('sabelUserId', initialData.sabelUserId);
            formik.setFieldValue('sabelUserName', initialData.sabelUserName);
        }
    }, [initialData]);

    return (
        <Modal
            title={initialData ? "Edit Siebel User" : "Create New Siebel User"}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={600}
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div className="row g-3">
                    <div className="col-md-12">
                        <label className="form-label">Siebel User ID</label> <span className="text-danger">*</span>
                        <input
                            type="text"
                            className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                            placeholder="Enter Siebel User ID"
                            name="sabelUserId"
                            value={formik.values.sabelUserId}
                            onChange={formik.handleChange}
                        />
                        {formik.touched.sabelUserId && formik.errors.sabelUserId && (
                            <span style={{ color: 'red' }} role="alert">{formik.errors.sabelUserId}</span>
                        )}
                    </div>

                    <div className="col-md-12">
                        <label className="form-label">Siebel User Name</label> <span className="text-danger">*</span>
                        <input
                            type="text"
                            className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                            placeholder="Enter Siebel User Name"
                            name="sabelUserName"
                            value={formik.values.sabelUserName}
                            onChange={formik.handleChange}
                        />
                        {formik.touched.sabelUserName && formik.errors.sabelUserName && (
                            <span style={{ color: 'red' }} role="alert">{formik.errors.sabelUserName}</span>
                        )}
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData ? "Update" : "Add"}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

CreateSebelUser.propTypes = {
    visible: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    initialData: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
};

export default CreateSebelUser;
